<script setup lang="ts">
import type { InstructionsDto } from '@/api/generator';

defineProps<{
  instructions: InstructionsDto | undefined;
}>();
</script>

<template>
  <div class="instructions-section">
    <p class="v-label-overwrite">
      {{ $t('InstructionManualLabel') }}
    </p>

    <div v-if="instructions" class="d-flex align-center justify-start ga-1 mt-2">
      <img class="handbook" :src="`data:image/png;base64,${instructions.icon1}`" alt="ISO 7010" />
      <img class="handbook" :src="`data:image/png;base64,${instructions.icon2}`" alt="" />
      <a class="v-label-overwrite align-self-center" :href="instructions.link" target="_blank">{{
        instructions.link
      }}</a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.handbook {
  margin-right: 8px;
  width: 38px;
  height: 38px;
}
</style>
